import linkedin from './linkedin.svg'
import whatsapp from './whatsapp.svg'
import gmail from './gmail.svg'
import twitter from './twitter.svg'
import github from './github.svg'

const Contact = () => {
  return (
    <div className="contact">
      <div className="contact-info">
          <h2>
            <span className="strikethrough">Give me your money!</span><br /> Say Hello.
          </h2>
          <p>
            <i>eghosaomuemu@gmail.com<br />+2348094656402</i>
          </p>
      </div>
      <div className="socials">
        <a href="https://www.linkedin.com/in/eghosa-omuemu/" target={"blank"}>
          <img src={linkedin} alt="linkedin" />
        </a>
        <a href="https://wa.me/qr/4EUDAXT4R2RJM1" target={"blank"}>
          <img src={whatsapp} alt="whatsapp" />
        </a>
        <a href="mailto:eghosaomuemu@gmail.com" target={"blank"}>
          <img src={gmail} alt="gmail" />
        </a>
        <a href="https://twitter.com/EghosaOmuemu?t=Vf827c1YARMDuxeVV8Opzg&s=35" target={"blank"}>
          <img src={twitter} alt="twitter" />
        </a>
        <a href="https://github.com/EghosaOmuemu" target={"blank"}>
          <img src={github} alt="github" />
        </a>
      </div>
      <br />
      <footer>
        <p>Designed & Built by Eghosa Omuemu.</p>
        <p>&copy; MMXXII.</p>
      </footer>
    </div>
  );
}

export default Contact